import { GameVars } from "../GameVars";
import { PauseMenu } from "./PauseMenu";
import { MatchManager } from "../MatchManager";

export class PowerUpButtonsContainer extends Phaser.Group {

    private static BUTTONS_PX = [730, 667, 604, 541];
    private static BUTTONS_PY = 108;

    private freezeGoalKeeperButton: Phaser.Button;
    private extraBallsButton: Phaser.Button;
    private ballOfFireButton: Phaser.Button;
    private voodooButton: Phaser.Button;
    private pulseTweens: Phaser.Tween[];

    constructor(game: Phaser.Game) {

        super(game, null, "powerup-buttons-container", false);

        this.scale.y = GameVars.scaleY;

        this.pulseTweens = [];

        this.freezeGoalKeeperButton = new Phaser.Button(this.game, 0, PowerUpButtonsContainer.BUTTONS_PY, "texture_atlas_5", this.onClickFreezeGoalkeeper, this);
        this.freezeGoalKeeperButton.setFrames("use_powerup_freeze_goalkeeper_on", "use_powerup_freeze_goalkeeper_off", "use_powerup_freeze_goalkeeper_on");
        this.freezeGoalKeeperButton.anchor.setTo(.5);
        this.freezeGoalKeeperButton.visible = false;
        this.freezeGoalKeeperButton.forceOut = true;
        this.add(this.freezeGoalKeeperButton);

        this.extraBallsButton = new Phaser.Button(this.game, 0, PowerUpButtonsContainer.BUTTONS_PY, "texture_atlas_5", this.onClickExtraBalls, this);
        this.extraBallsButton.setFrames("use_powerup_3_balls_on", "use_powerup_3_balls_off", "use_powerup_3_balls_on");
        this.extraBallsButton.anchor.setTo(.5);
        this.extraBallsButton.visible = false;
        this.extraBallsButton.forceOut = true;
        this.add(this.extraBallsButton);

        this.ballOfFireButton = new Phaser.Button(this.game, 0, PowerUpButtonsContainer.BUTTONS_PY, "texture_atlas_5", this.onClickBallOfFire, this);
        this.ballOfFireButton.setFrames("use_powerup_ball_of_fire_on", "use_powerup_ball_of_fire_off", "use_powerup_ball_of_fire_on");
        this.ballOfFireButton.anchor.setTo(.5);
        this.ballOfFireButton.visible = false;
        this.ballOfFireButton.forceOut = true;
        this.add(this.ballOfFireButton);

        this.voodooButton = new Phaser.Button(this.game, 0, PowerUpButtonsContainer.BUTTONS_PY, "texture_atlas_5", this.onClickVoodoo, this, 1, 0, 1);
        this.voodooButton.setFrames("use_powerup_voodoo_on", "use_powerup_voodoo_off", "use_powerup_voodoo_on");
        this.voodooButton.anchor.setTo(.5);
        this.voodooButton.visible = false;
        this.voodooButton.forceOut = true;
        this.add(this.voodooButton);
    }

    public onBallsManagerReadyToKickOff(): void {

        this.updatePowerUpButtons();

        this.visible = true;
    }

    public onKickOff(): void {

        this.visible = false;

        // quitar tweens gomosos a los botones
        let i = this.pulseTweens.length;

        while (i--) {
            this.pulseTweens[i].pendingDelete = true;
        }

        this.pulseTweens.length = 0;
    }

    public updatePowerUpButtons(): void {

        let i = 3;
        let pulseDelay = 0;

        // el voodoo solo se puede usar una vez por partida
        if (GameVars.gameData.powerUpState.voodooPurchased && !GameVars.voodooUsed) {
            this.voodooButton.x = PowerUpButtonsContainer.BUTTONS_PX[i];
            this.voodooButton.visible = true;
            this.addPulseTween(this.voodooButton, pulseDelay);
            pulseDelay += 100;
            i--;
        } else {
            this.voodooButton.visible = false;
        }

        if (GameVars.gameData.powerUpState.ballOfFirePurchased) {
            this.ballOfFireButton.x = PowerUpButtonsContainer.BUTTONS_PX[i];
            this.ballOfFireButton.visible = true;
            this.addPulseTween(this.ballOfFireButton, pulseDelay);
            pulseDelay += 100;
            i--;
        } else {
            this.ballOfFireButton.visible = false;
        }

        if (GameVars.gameData.powerUpState.extraBallsPurchased) {
            this.extraBallsButton.x = PowerUpButtonsContainer.BUTTONS_PX[i];
            this.extraBallsButton.visible = true;
            this.addPulseTween(this.extraBallsButton, pulseDelay);
            pulseDelay += 100;
            i--;
        } else {
            this.extraBallsButton.visible = false;
        }

        if (GameVars.gameData.powerUpState.freezeGoalkeeperPurchased && !GameVars.voodooUsed) {
            this.freezeGoalKeeperButton.x = PowerUpButtonsContainer.BUTTONS_PX[i];
            this.freezeGoalKeeperButton.visible = true;
            this.addPulseTween(this.freezeGoalKeeperButton, pulseDelay);
        } else {
            this.freezeGoalKeeperButton.visible = false;
        }

        // actualizar el powerup container del menu de pausa
        PauseMenu.currentInstance.powerUpsContainer.updateContainer();
    }

    private onClickFreezeGoalkeeper(): void {

        this.visible = false;

        this.updatePowerUpButtons();
        MatchManager.onPowerUpFreezeGoalkeeperSelected();
    }

    private onClickExtraBalls(): void {

        this.visible = false;

        this.updatePowerUpButtons();
        MatchManager.onPowerUpExtraBallsSelected();
    }

    private onClickBallOfFire(): void {

        this.visible = false;

        this.updatePowerUpButtons();
        MatchManager.onPowerUpBallOfFireSelected();
    }

    private onClickVoodoo(): void {

        this.visible = false;

        this.updatePowerUpButtons();
        MatchManager.onPowerUpVoodooSelected();
    }

    private addPulseTween(button: Phaser.Button, pulseDelay: number): void {

        let pulseTween = this.game.add.tween(button.scale);
        pulseTween.to({ x: 1.05, y: .95 }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50 + pulseDelay);
        pulseTween.to({ x: .95, y: 1.05 }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();

        this.pulseTweens.push(pulseTween);
    }
}
